import { combineReducers } from 'redux'
import ui from './ui';
import gloops from "./gloops";

export const  reducers = combineReducers({
	test : function (state={}) {
		return state;
	},
	active : function (state = false,action) {
		if(action.type == 'ACTIVATE'){
			return true;
		}
		if(action.type == 'DEACTIVATE'){
			return false;
		}
		if(action.type == 'SET ERROR'){
			return true;
		}
		return  state;
	},
	gloopsOptions : function (state = {}, action) {
		if(action.type == 'UPDATE GLOOP OPTIONS'){
			state = Object.assign({},state, {[action.data.id] : action.data})
		}
		return  state;
	},
	gloops : gloops,
	activeGloop : function (state = 0 , action) {
		if(action.type == 'SET ACTIVE GLOOP'){
			state = action.id
		}
		if(action.type == 'DEACTIVATE'){
			return false;
		}
		return  state;
	},
	activeScreen : function (state = 'gloop', action) {
		if(action.type == 'SET SCREEN'){
			state = action.data
		}
		return  state;
	},
	ui : ui,
	videoVersion : function (state = 'gloop', action) {
		if(action.type == 'UPDATE VIDEO VERSION'){
			return ++state
		}
		return state;
	},
	error : function (state ='', action) {
		if(action.type == 'SET ERROR'){
			state = action.data;
		}
		return state;
	}
});
